<template lang="pug">
  button(@click="back") 前の画面へ戻る
</template>

<script lang="js">
export default {
  methods: {
    back() {
      history.back();
    },
  },
};
</script>